import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { SystemEventListPanel } from "@/features/admin/components/system-event-list-panel";

const SECTIONS = [
  { value: "MT_MEDIA", label: "Social Media" },
  { value: "MT_EMAILS", label: "Emails" },
  { value: "MT_LETTERS", label: "Letters / Printable" },
  { value: "MT_BOOKS", label: "Handbooks" },
] as const;

/** Marketing Toolbox editor (`/admin/toolbox`) — four ordered sections. */
export default function ToolboxPage() {
  return (
    <Tabs defaultValue={SECTIONS[0].value}>
      <TabsList>
        {SECTIONS.map((s) => (
          <TabsTrigger key={s.value} value={s.value}>
            {s.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {SECTIONS.map((s) => (
        <TabsContent key={s.value} value={s.value} className="mt-4">
          <SystemEventListPanel
            title={s.label}
            addLabel="Add item"
            resource="toolbox"
            selector={{ param: "section", value: s.value }}
            fields={["badge", "title", "detail", "href"]}
            columns={[
              {
                header: "Badge",
                cell: (e) => (e.badge ? <Badge>{e.badge}</Badge> : "—"),
              },
              { header: "Title", cell: (e) => <span className="font-medium">{e.title}</span> },
              { header: "URL", cell: (e) => e.href || "—" },
            ]}
          />
        </TabsContent>
      ))}
    </Tabs>
  );
}
